<template>
  <FullScreenModal
    :is-open="open"
    @onClose="$emit('close')"
    vertical-alignment="center"
    white-close-btn
    :dismissable="dismissable"
  >
    <div class="background-container position-relative h-100">
      <div
        class="content text-center position-absolute top-0 start-0 end-0 mt-3"
      >
        <h1 class="title text-white mb-3 mt-5">
          {{ t("WITHDRAWAL_REQUEST_CARD_BANNER.TITLE") }}
          <span class="subtitle">
            {{ t("WITHDRAWAL_REQUEST_CARD_BANNER.SUBTITLE") }}
          </span>
        </h1>
        <p
          class="description text-white mt-3"
          v-html="t('WITHDRAWAL_REQUEST_CARD_BANNER.DESCRIPTION')"
        />
        <img
          :src="useAsset('img/credit-line/credit-card/yourFunds.png')"
          alt="your funds"
          class="card-image mt-4"
        />
      </div>
      <Button
        @click="continueBtn"
        class="request-btn position-absolute bottom-0 start-50 translate-middle-x mb-5"
        :greenBackground="true"
      >
        <span class="d-flex align-items-center justify-content-center">
          <img
            :src="useAsset('img/credit-line/credit-card/credit_card_green.png')"
            alt="pc svg"
            style="width: 24px; height: 24px"
            class="me-2"
          />
          {{
            shouldHaveCardInHand
              ? t("WITHDRAWAL_REQUEST_CARD_BANNER.CARD_IN_HAND_CTA")
              : t("WITHDRAWAL_REQUEST_CARD_BANNER.BUTTON")
          }}
        </span>
      </Button>
    </div>
  </FullScreenModal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import FullScreenModal from "@/apps/credit-line/components/FullScreenModal.vue";
import useAsset from "@/apps/credit-line/helpers/useAsset";
import Button from "@/apps/credit-line/components/Button.vue";
import { useRouter } from "vue-router";
import { useI18n } from "@/apps/credit-line/composables/useI18n";

export default defineComponent({
  name: "RequestCardBanner",
  methods: { useAsset },
  components: { Button, FullScreenModal },
  props: {
    open: Boolean,
    dismissable: Boolean,
    shouldHaveCardInHand: Boolean,
  },
  emits: ["close", "continue"],
  setup(props) {
    const { t } = useI18n();
    const router = useRouter();

    const continueBtn = () => {
      if (props.shouldHaveCardInHand) {
        router.push({ name: "CreditCardView" });
      } else {
        router.push({ name: "CreditCardShippingAddressView" });
      }
    };

    return { t, continueBtn };
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/constants";

html,
body * {
  font-family: Inter;
}

.background-container {
  background-color: $pj-color-green;
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
}

.content {
  z-index: 1;
  padding: 0 1rem;
}

.title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #fff;
}

.description {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
}

.subtitle {
  display: block;
  font-size: 1.5rem;
  font-weight: 600;
  color: #c7fd17;
}

.request-btn {
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  bottom: 5%;
  height: 56px;
  padding: 10px 24px;
  font-size: medium;
  border-radius: 10px;
  font-weight: 800;
  font-style: normal;
  line-height: 20px;
  letter-spacing: -0.2px;
  width: 90%;
  border: none;
}

.card-image {
  width: 100%;
  height: auto;
}
</style>
